import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { FavoriteIcon, RecordVoiceOverIcon } from '@/assets';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  onAllFunksPress: () => void;
  onMentionedPress: () => void;
};

export const OrganizationDetailActivitiesSection: FC<Props> = ({
  onAllFunksPress,
  onMentionedPress
}) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.ORGANIZATION, {
    keyPrefix: 'organization-detail'
  });
  const rowBackground = theme.colors.surfaceContainerLowest;

  return (
    <ListSection
      title={t('sections.activities')}
      style={styles.section}
      headerBackgroundColor="transparent"
    >
      <ListItem
        title={t('rows.allFunks')}
        icon={RecordVoiceOverIcon}
        backgroundColor={rowBackground}
        onPress={onAllFunksPress}
      />
      <ListItem
        title={t('rows.mentioned')}
        icon={FavoriteIcon}
        backgroundColor={rowBackground}
        onPress={onMentionedPress}
      />
    </ListSection>
  );
};

const styles = StyleSheet.create({
  section: { backgroundColor: 'transparent' }
});
